export default __webpack_public_path__ + "static/media/vintage-man.ed1c511f.svg";